import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { customersAccessRoles } from './access';

export const customersRoutes: RouteObject[] = [
  {
    path: 'customers',
    async lazy() {
      const { CustomersPage } = await import('./pages/CustomersPage');
      return { Component: CustomersPage };
    },
    handle: defineHandle({
      roles: [...customersAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.customers',
    }),
  },
];
